import './polyfills'
import { unmount } from 'svelte'
import { instantiate } from './App'

let onDestroy
let selectorInstance
let backdropInstance

export const launch = (config) => {
  onDestroy = config.onDestroy
  ;({ selectorInstance, backdropInstance } = instantiate(config))
}

export const destroy = () => {
  unmount(selectorInstance)
  unmount(backdropInstance)

  if (onDestroy) {
    onDestroy()
  }
}
